var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logo.png")}}),_c('el-button',[_vm._v("12121")]),_c('p',[_vm._v(_vm._s(_vm.$t('h.欢迎')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }